import { render, staticRenderFns } from "./SparePartDialog.vue?vue&type=template&id=0ec8bb00"
import script from "./SparePartDialog.vue?vue&type=script&lang=ts"
export * from "./SparePartDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports